import React from 'react';
import { connect } from 'react-redux';
import { fetchLinkedFlows } from '../redux/actions';

import FlowCard from '../components/availableFlows/FlowCard';
import { Box, Grid, Typography } from '@mui/material';
import LoadingDial from '../components/loading/LoadingDial';

import { getLocalization } from '../redux/selectors';

const AvailableFlows = (props) => {
  const { flows, fetchLinkedFlows, filter } = props;
  const { supportedFlows, linkedFlows } = flows;
  const localization = getLocalization();

  React.useEffect(() => {
    if (!flows) return;

    const { linkedFlowsStatus } = flows;

    if (!linkedFlowsStatus) fetchLinkedFlows();
  }, [flows]);

  if (!linkedFlows)
    return (
      <Grid
        container
        sx={{
          height: 'calc(600px - 88px)',
        }}
      >
        <Grid item xs={12}>
          <LoadingDial />
        </Grid>
      </Grid>
    );

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        position="sticky"
        top={0}
        pb={2.5}
        sx={{
          bgcolor: 'background.paper',
          zIndex: 10,
        }}
      >
        <Box display="flex" flexDirection="column" gap={1}>
          <Typography variant="h1">{localization?.startingScreen?.header || 'Connect your data'}</Typography>
          <Typography variant="body1" color="text.lightish" fontWeight="300">
            {localization?.startingScreen?.subtitle || 'Select preferred category below.'}
          </Typography>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        gap={3}
        display="flex"
        flexDirection="column"
        sx={{
          '& > div:first-of-type': {
            mt: 1,
          },
          '& > div:last-child': {
            mb: 3,
          },
        }}
      >
        {Object.entries(linkedFlows)
          .filter(([key, value]) => !filter?.flowFilter || filter.flowFilter(value))
          .sort(([k1, v1], [k2, v2]) => {
            if (v1.name < v2.name) return -1;

            if (v1.name > v2.name) return 1;

            return 0;
          })
          .map(([key, value], i) => (
            <FlowCard {...value} key={i + key} linked={true} />
          ))}
        {Object.entries(supportedFlows)
          .filter(([key, value]) => linkedFlows[key] == undefined)
          .filter(([key, value]) => !filter?.flowFilter || filter.flowFilter(value))
          .sort(([k1, v1], [k2, v2]) => {
            if (v1.name < v2.name) return -1;

            if (v1.name > v2.name) return 1;

            return 0;
          })
          .map(([key, value], i) => (
            <FlowCard {...value} key={i * 10 + key} />
          ))}
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state, props) => {
  return {
    flows: state.flows,
    filter: state.configuration.filter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchLinkedFlows: () => dispatch(fetchLinkedFlows()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailableFlows);
